module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.noContent) ? _c('div', {
    staticClass: "content-loader-placeholder"
  }, [(_vm.type === 'AnalyticsUnitBlock') ? _c('analytics-unit-block-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AudienceProfileLoader') ? _c('audience-profile-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AnalyticsHeatMapLoader') ? _c('div', [_c('content-loader', {
    attrs: {
      "height": Math.abs(_vm.sizeReducer[1]),
      "width": Math.abs(_vm.sizeReducer[0]),
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "71",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "257",
      "y": "38",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'WordCloudLoader') ? _c('word-cloud-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'TimeSeriesGraphLoader') ? _c('time-series-graph-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'ListDividerLoader') ? _c('list-divider-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'EngagementGraphLoader') ? _c('engagement-graph-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'ProgrammingDashboardUnitLoader') ? _c('programming-dashboard-unit-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AnalyticsChartLoader') ? _c('analytics-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'DoughnutChartLoader') ? _c('doughnut-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'PolarChartLoader') ? _c('polar-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AdvertisersChartLoader') ? _c('advertisers-chart-loader') : _vm._e()], 1) : _c('span', [_c('content-placeholder', {
    staticStyle: {
      "width": "100%",
      "min-height": "200px",
      "display": "block"
    },
    attrs: {
      "slot": "unit-content",
      "text-value": "Not enough data available",
      "text-array": !_vm.noContent && ['Not enough data available.', 'Try running some Competition campaigns.'],
      "text-only": true,
      "count": 1
    },
    slot: "unit-content"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552257f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/ContentLoaderPlaceholder.vue
// module id = 3286
// module chunks = 3